// @flow
import React, { Fragment } from "react";
import ReactModal from "react-modal";

type Props = {
  id: number,
  onClose: ?Function
};

type State = {
  loaded: boolean,
  html: ?string
};

const customStyles = {
  overlay: {
    zIndex: 999999999
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    borderRadius: 10,
    borderColor: "#",
    maxHeight: "90vh",
    overflowY: "scroll"
  }
};

export default class Modal extends React.Component<Props, State> {
  state = {
    loaded: false,
    html: null
  };

  render() {
    const { loaded, html } = this.state;
    const { onClose } = this.props;
    return (
      <ReactModal
        isOpen={true}
        // onAfterOpen={this.afterOpenModal}
        ariaHideApp={false}
        onRequestClose={onClose}
        style={customStyles}
      >
        {!loaded && "Loading..."}
        {loaded && <div dangerouslySetInnerHTML={{ __html: html }} />}
      </ReactModal>
    );
  }
}
